export default {
  projects: [
    {
      name: "taskrelieved",
      image: "https://firebasestorage.googleapis.com/v0/b/portfolio-1b888.appspot.com/o/photos%2Ftaskrelieved-mobile.jpg?alt=media&token=22aea661-4d55-4020-8bb7-5c7873fba7f7",
      description:
        "Task Relieved is an economical platform that allows users to get tasks done reasonably and conveniently while providing financial opportunities for task-doers via bidding.   ",
      gitHub: "",
      live: "https://www.taskrelieved.com/",
      fullDescription: "Task Relieved is an economical platform that allows users to get tasks done reasonably and conveniently while providing financial opportunities for task-doers via bidding.",
      techStack: [
        'yarn',
        'babelrc',
        'javascript',
        'Webpack',
        'jest',
        'scss',
        'node-sass',
        'webpack',
        'sparetime.js'],
       technical: ''
    },
    {
      name: "Bounce",
      image:"https://firebasestorage.googleapis.com/v0/b/portfolio-1b888.appspot.com/o/photos%2FbounceIphoneX.jpg?alt=media&token=c4a84378-29d8-4214-86f6-5f9dcf149257",
      description:
          "Affordable tutoring for the world.",
      gitHub: "",
      live: "https://demo.bounce.so/",
      fullDescription: "Students can learn from teachers in realtime environment. ",
      techStack: [
        'Rails',
        'aws',
        'yarn',
        'React',
        'babelrc',
        'javascript',
        'Webpack',
        'scss',
        'node-sass',
        'webpack'
      ],
      technical: ""
     },
    {
      name: "RipReview",
      image:"https://firebasestorage.googleapis.com/v0/b/portfolio-1b888.appspot.com/o/photos%2Fcompressed%20%2Fmac_rip_review.jpg?alt=media&token=65f4d18e-c640-4b1a-8c83-169f7a05a6f2",
      description:
          "A user review app that enables users to have a say about their day to day experiences with businesses.",
      gitHub: "",
      live: "https://reviewtt.netlify.com/",
      fullDescription: "This applications was create with react and rails running on separate servers. " +
          "I leverage rails to build the api backend. " +
          "I used JWT (Json web token) approach for authentication " +
          "This app allows users to upload reviews and comment on other reviews about their experiences with businesses. " +
          "Features are: User authentication, uploading reviews, commenting on reviews and rate reviews. ",
      techStack: [
        'Rails',
        'aws',
        'yarn',
        'React',
        'babelrc',
        'javascript',
        'Webpack',
        'scss',
        'node-sass',
        'webpack'
      ],
      technical: 'User create reviews about there experiences with companies ' +
          'Users can comment and rate each review,' +
          'User authentication'
     },

    {
      name: "Goodness and Mercy",
      image: "https://firebasestorage.googleapis.com/v0/b/portfolio-1b888.appspot.com/o/photos%2Fcompressed%20%2Fgoodness.jpg?alt=media&token=b94cc6eb-6022-4e29-819e-d1bd709dfe1b",
      description:
        "A Full-Stack application built for a church ministry dedicated to reaching lost souls",
      gitHub: "",
      live: "https://goodness-and-mercies.herokuapp.com/",
      fullDescription: "This web app was built for a church." +
          "It allows members to consume recent sermons and receive emails when events are near. " +
          "Some technical challenges were: implementing automation of notifying members when a event is near." +
          " For my  solution  I leveraged rails_jobs and Sidekiq job scheduler",
      techStack: [
        'yarn',
        'babelrc',
        'javascript',
        'Webpack',
        'scss',
        'webpack',
        'rails'
      ],
      technical: ''
    },
    {
      name: "BattleShip",
      image: "https://firebasestorage.googleapis.com/v0/b/portfolio-1b888.appspot.com/o/photos%2Fcompressed%20%2Fmac_battleship.jpg?alt=media&token=4618e050-1801-4cbe-86e1-fc673860d97f",
      description:
        "A web app designed to mimic Battleship, a strategy type guessing game for two players.",
      gitHub:
        "https://github.com/Ispirett/javascript-battleship/blob/development/README.md",
      live: "https://ispirett.github.io/javascript-battleship/",
      fullDescription:
        "The game of Battleship is thought to have its origins in the French game L'Attaque played during World War I, although parallels have also been drawn to E. I. Horsman's 1890 game Basilinda,[2] and the game is said to have been played by Russian officers before World War " +
        "I.[3] The first commercial version of the game was Salvo, published in 1931 in the United States by the Starex company." +
        " Other versions of the game were printed in the 1930s and 1940s, including the Strathmore Company's Combat: The Battleship Game," +
        " Milton Bradley's Broadsides: A Game of Naval Strategy and Maurice L. Freedman's Warfare Naval Combat. " +
        "Strategy Games Co. produced a version called Wings which pictured planes flying over the Los Angeles Coliseum." +
        " All of these early editions of the game consisted of pre-printed pads of paper.[2]",
      techStack: [
        'yarn',
        'babelrc',
        'javascript',
        'Webpack',
        'jest',
        'scss',
        'node-sass',
        'webpack',
        'sparetime.js'],
      technical: ''
    },

    // {
    //   name: "Clem",
    //   image:
    //       "https://hdwallpapers.imgix.net/wallpaper-36461567703744jny526nlq7.jpg?auto=compress&cs=tinysrgb&dpr=1",
    //   description:
    //       "A realtime application that connects teachers and students. Students can request sessions with teachers and pay a small fee to learn specific topics",
    //   gitHub: "",
    //   live: "",
    //   fullDescription: "",
    //
    //   techStack: [
    //     'yarn',
    //     'babelrc',
    //     'javascript',
    //     'Webpack',
    //     'jest',
    //     'scss',
    //     'node-sass',
    //     'webpack',
    //     'sparetime.js'],
    //   technical: ''
    // },

    {
      name: "The Red Affair",
      image: "https://firebasestorage.googleapis.com/v0/b/portfolio-1b888.appspot.com/o/photos%2Fcompressed%20%2Fmac_restatruant.jpg?alt=media&token=c4813dec-1704-479d-bb23-891e29b8d3ac",
      description:
          "A restaruant with  class and style",
      gitHub: "https://github.com/Ispirett/weather-app",
      live: "https://ispirett.github.io/javascript-restaurant/",
      fullDescription: "This project was built entirely with javascript's dom api. In this project i used modern javascript features like: es6 modules," +
          " arrows, " +
          "destructuring, factory_functions and template strings.",

      techStack: [
        'npm',
        'javascript',
        'Webpack',
        'scss',
        'node-sass',
        'webpack',
        ],
      technical: ''
    },


    {
      name: "Sparetime.js",
      image: "https://firebasestorage.googleapis.com/v0/b/portfolio-1b888.appspot.com/o/photos%2Fcompressed%20%2Fmac_spartime.jpg?alt=media&token=9996480d-a7e5-4361-858e-956b22870742",
      description:
          "A dom manipulation library that saves you time",
      gitHub: "https://github.com/Ispirett/Sparetime.js",
      live: "",
      fullDescription: "This project was built in an effort to make dom manipulation more efficient for my programming partners and I " +
          "while developing projects for our school projects." +
          " Technologies used are above in the tech stack section. ",

      techStack: [
        'yarn',
        'babelrc',
        'javascript',
        'Typescript',
        'webpack',
        'sparetime.js'],
      technical: ''
    },

    {
      name: "The Weather",
      image: "https://firebasestorage.googleapis.com/v0/b/portfolio-1b888.appspot.com/o/photos%2Fcompressed%20%2Fmac_waather.jpg?alt=media&token=12a533c9-1a67-47d1-86df-1c7bd0b13144",
      description:
          "Get details about the weather forecast in any city worldwide.",
      gitHub: "https://github.com/Ispirett/weather-app",
      live: "https://ispirett.github.io/weather-app/",
      fullDescription: "This app was built using technologies in the TechStack below and leveraging the open weather api.",

      techStack: [
        'yarn',
        'javascript',
        'Webpack',
        'Typescript',
        'scss',
        'node-sass',
        'sparetime.js'],
      technical: ''
    },

  ]
};
